import {Component, AfterViewInit} from '@angular/core';
import {LocalStorageService} from "./services/LocalStorage.service";
import {Router, NavigationEnd, RouterStateSnapshot} from "@angular/router";
import {ROUTE_CONSTANTS} from "./common/constant/RouteConstants";
import {Login} from "./shared/Login";
import {LoginService} from "./services/login.service";
import {CommonService} from "./services/common.service";
import {ONLINE_APP_CONSTANTS} from "./common/constant/OnlineAppConstants";

declare var $: any
@Component({
  selector: 'oa-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements AfterViewInit {

  public constructor(
    private _route : Router,
    private _localStorageService : LocalStorageService,
    private _loginService : LoginService,
    private _commonService : CommonService) {

    this.checkUserToken();

    this._route.events.subscribe((val) => {
      //console.log(val instanceof NavigationEnd);
      if(val instanceof NavigationEnd)
      {
        if(this._localStorageService.getUserId() > 0)
          this._localStorageService.setActiveIndexFromURL(val.urlAfterRedirects.toString());
      }
    });
    window.onresize = (e) =>
    {
      $.fn.hasScrollBar = function () {
        return this.get(0).scrollHeight > this.height();
      }
      if ($('body.wrapper').length > 0 && $('body.wrapper').hasScrollBar()) {
        $('.footer.navbar-fixed-bottom').css({"position": "relative", "margin-top": "30px"});
      }
    };

  }

  ngAfterViewInit() {
    setTimeout(function () {
        $.fn.hasScrollBar = function () {
          return this.get(0).scrollHeight > this.height();
        }
        if ($('body.wrapper').length > 0 && $('body.wrapper').hasScrollBar()) {
          $('.footer.navbar-fixed-bottom').css({"position": "relative", "margin-top": "30px"});
        }
    }, 1200);
  }

  checkUserToken(){
    console.log("checkUserToken");
    let resultLogin : Login = new Login();
    //console.log("this._localStorageService.getIsRemember() = "+ this._localStorageService.getIsRemember());
    //console.log("Authorization =" + this._commonService.getItem("Authorization" ,""));
    if(this._localStorageService.getIsRemember() && this._commonService.getItem("Authorization" ,"") !== ""
      && this._commonService.getItem("Authorization" ,"") !== null)
    {
      this._loginService.getAuthenticateUser().subscribe(
        data => {
          //console.log("response = "+ JSON.stringify(data));
          if (data.statusCode == "T200") {
            resultLogin = data.dataObject;
            this._localStorageService.setUserId(resultLogin.id);
            this._localStorageService.setLoginUser(resultLogin.username);
            this._localStorageService.setIsRemember(this._localStorageService.getIsRemember());
          }
        },
        err => {
          console.error("Error From checkUserToken  : " + JSON.stringify(err));
          this._route.navigate([ROUTE_CONSTANTS.LOGIN]);
        }
      );
    }
    else if (!this._localStorageService.getIsRemember() && this._commonService.getItem("Authorization" ,"") !== ""
      && this._commonService.getItem("Authorization" ,"") !== null )
    {
      if(!this._localStorageService.isUserLoggedIn()) {

        if(this._route.url != ROUTE_CONSTANTS.ROOT &&
          this._route.url != ROUTE_CONSTANTS.CREATE_NEW_USER
          && this._route.url != ROUTE_CONSTANTS.WELCOME
          && this._route.url != ROUTE_CONSTANTS.LOGIN)
        {
          this._route.navigate([ROUTE_CONSTANTS.LOGIN]);
        }

      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts